import { Select } from "@tfg/ui"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { ProdsiteRequestStatus } from "~/pages/SupplierPortal/TraceabilityRequests/components/ProdsiteRequests"

type ProdsiteRequestStatus =
  (typeof ProdsiteRequestStatus)[keyof typeof ProdsiteRequestStatus]
type Props = {
  status: ProdsiteRequestStatus | undefined
  setStatus: Dispatch<SetStateAction<ProdsiteRequestStatus | undefined>>
}

export const ProdsiteRequestStatusFilter = ({ status, setStatus }: Props) => {
  const { t } = useTranslation(["traceability"])

  const STATUS_OPTIONS: { label: string; value: ProdsiteRequestStatus }[] = [
    {
      label: t("filters.status.opened"),
      value: ProdsiteRequestStatus.OPEN,
    },
    {
      label: t("filters.status.closed"),
      value: ProdsiteRequestStatus.CLOSED,
    },
  ]
  return (
    <Select
      placeholder={t("filters.status.placeholder")}
      value={status ?? null}
      onChange={(val) => {
        if (val && isProdsiteRequestStatus(val)) {
          setStatus(val)
        } else {
          setStatus(undefined)
        }
      }}
      data={STATUS_OPTIONS}
      w={180}
      clearable
    />
  )
}

const isProdsiteRequestStatus = (val: string): val is ProdsiteRequestStatus => {
  return Object.keys(ProdsiteRequestStatus).includes(val)
}
